<div class="manual-container">
  <!-- Sidebar TOC -->
  <div class="manual-sidebar">
    <div class="sidebar-header">
      <h4><i class="fa fa-book"></i> User Manual</h4>
    </div>

    <!-- Search -->
    <div class="sidebar-search">
      <input type="text" class="form-control form-control-sm" placeholder="Search manual..."
             [(ngModel)]="searchText" (ngModelChange)="onSearchChange()" />
    </div>

    <!-- Audience Filter -->
    <div class="sidebar-filter">
      <select class="form-control form-control-sm" [(ngModel)]="audienceFilter">
        <option value="all">All Content</option>
        <option value="user">End User Only</option>
        <option value="admin">Admin/IT Only</option>
      </select>
    </div>

    <!-- Expand/Collapse -->
    <div class="sidebar-actions">
      <a href="javascript:void(0)" (click)="expandAll()" class="small">Expand All</a>
      <span class="text-muted mx-1">|</span>
      <a href="javascript:void(0)" (click)="collapseAll()" class="small">Collapse All</a>
      <span class="text-muted mx-1">|</span>
      <a href="javascript:void(0)" (click)="printManual()" class="small"><i class="fa fa-print"></i> Print</a>
    </div>

    <!-- TOC -->
    <nav class="sidebar-nav">
      <ul class="toc-list" *ngFor="let section of (sections | manualSearch:searchText:audienceFilter)">
        <li class="toc-section" [class.active]="activeSection === section.id">
          <a href="javascript:void(0)" (click)="toggleSection(section.id); scrollToSection(section.id)">
            <i class="fa {{ section.icon }} toc-icon"></i>
            <span>{{ section.title }}</span>
            <span *ngIf="section.audience !== 'both'" class="badge badge-sm"
                  [class.badge-info]="section.audience === 'admin'"
                  [class.badge-secondary]="section.audience === 'user'">
              {{ getAudienceBadge(section.audience) }}
            </span>
            <i class="fa fa-chevron-down toc-chevron" [class.expanded]="expandedSections[section.id]"></i>
          </a>
          <ul class="toc-subsections" *ngIf="expandedSections[section.id]">
            <li *ngFor="let sub of section.subsections">
              <a href="javascript:void(0)" (click)="scrollToSubsection(section.id, sub.id)">
                {{ sub.title }}
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </nav>
  </div>

  <!-- Main Content -->
  <div class="manual-content">
    <div class="content-inner">
      <div *ngFor="let section of (sections | manualSearch:searchText:audienceFilter)">
        <div [id]="section.id" class="manual-section">
          <h2 class="section-title">
            <i class="fa {{ section.icon }}"></i> {{ section.title }}
            <button type="button"
                    class="manual-link-button"
                    title="Copy link to this section"
                    (click)="copySectionLink(section.id)">
              <i class="fa" [class.fa-link]="copiedAnchor !== section.id" [class.fa-check]="copiedAnchor === section.id"></i>
            </button>
            <span *ngIf="section.audience !== 'both'" class="badge ml-2"
                  [class.badge-info]="section.audience === 'admin'"
                  [class.badge-secondary]="section.audience === 'user'">
              {{ getAudienceBadge(section.audience) }}
            </span>
          </h2>
          <hr />

          <div *ngFor="let sub of section.subsections" [id]="sub.id" class="manual-subsection">
            <h3 class="subsection-title">
              {{ sub.title }}
              <button type="button"
                      class="manual-link-button manual-link-button-sm"
                      title="Copy link to this section"
                      (click)="copySectionLink(sub.id)">
                <i class="fa" [class.fa-link]="copiedAnchor !== sub.id" [class.fa-check]="copiedAnchor === sub.id"></i>
              </button>
              <span *ngIf="sub.audience !== 'both' && sub.audience !== section.audience" class="badge badge-sm ml-1"
                    [class.badge-info]="sub.audience === 'admin'"
                    [class.badge-secondary]="sub.audience === 'user'">
                {{ getAudienceBadge(sub.audience) }}
              </span>
            </h3>
            <div [innerHTML]="sub.content" class="subsection-content"></div>
          </div>
        </div>
      </div>

      <!-- Empty state -->
      <div *ngIf="(sections | manualSearch:searchText:audienceFilter).length === 0" class="text-center py-5">
        <i class="fa fa-search fa-3x text-muted mb-3"></i>
        <h4 class="text-muted">No matching sections found</h4>
        <p class="text-muted">Try a different search term or change the audience filter.</p>
      </div>
    </div>
  </div>
</div>
